import { render, staticRenderFns } from "./CommentUserProfile.vue?vue&type=template&id=42d695f8"
import script from "./CommentUserProfile.vue?vue&type=script&lang=js"
export * from "./CommentUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports